import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";

import {
  removeRequirementLocal,
  setRequirements,
  upsertRequirement,
} from "../outlineSlice";
import { ERROR_TITLE, getOwnerUrl } from "./shared";

export const fetchRequirements = (ownerType, ownerId) => async (dispatch) => {
  dispatch(addToJobQueue("fetchRequirements"));

  try {
    const url = `${getOwnerUrl(ownerType, ownerId)}/requirements`;
    const response = await localhost.get(url);
    dispatch(setRequirements(response.data));
    return response.data;
  } catch (error) {
    dispatch(showErrorModal(error, ERROR_TITLE));
    return null;
  } finally {
    dispatch(removeFromJobQueue("fetchRequirements"));
  }
};

export const addRequirement =
  (ownerType, ownerId, { restatedText, category }) =>
  async (dispatch) => {
    dispatch(addToJobQueue("addRequirement"));

    try {
      const url = `${getOwnerUrl(ownerType, ownerId)}/requirements`;
      const response = await localhost.post(url, { restatedText, category });
      dispatch(upsertRequirement(response.data));
      return response.data;
    } catch (error) {
      dispatch(showErrorModal(error, ERROR_TITLE));
      return null;
    } finally {
      dispatch(removeFromJobQueue("addRequirement"));
    }
  };

export const updateRequirement =
  (ownerType, ownerId, requirementId, { restatedText, category }) =>
  async (dispatch) => {
    dispatch(addToJobQueue("updateRequirement"));

    try {
      const url = `${getOwnerUrl(ownerType, ownerId)}/requirements/${requirementId}`;
      const response = await localhost.put(url, { restatedText, category });
      dispatch(upsertRequirement(response.data));
      return response.data;
    } catch (error) {
      dispatch(showErrorModal(error, ERROR_TITLE));
      return null;
    } finally {
      dispatch(removeFromJobQueue("updateRequirement"));
    }
  };

export const removeRequirement =
  (ownerType, ownerId, requirementId) => async (dispatch) => {
    dispatch(addToJobQueue("removeRequirement"));

    try {
      const url = `${getOwnerUrl(ownerType, ownerId)}/requirements/${requirementId}`;
      await localhost.delete(url);
      dispatch(removeRequirementLocal(requirementId));
      return true;
    } catch (error) {
      dispatch(showErrorModal(error, ERROR_TITLE));
      return false;
    } finally {
      dispatch(removeFromJobQueue("removeRequirement"));
    }
  };
